import Guid from "common/values/guid/guid";

export default class Subscriber {
    constructor(public userId: Guid, public entityId: Guid) { }
}